import React from 'react';

import Error404 from '../components/Error404';

const ErrorPage = () => <Error404 />;

export default ErrorPage;
